// New products precede the saved manual order; exposure and stock never change rank.
export function orderManagedProducts<T extends { seq: number; display_order?: number | null }>(products: T[]): T[] {
  const rank = (product: T) => Number.isInteger(product.display_order) && product.display_order !== 2147483647
    ? product.display_order! : -1;
  return [...products].sort((a, b) => rank(a) - rank(b) || b.seq - a.seq);
}
